module.exports = __webpack_public_path__ + "media/images/doc-e2f59feb8c62c0d45115b371167469c5.svg";